import { getEnvNumber, getEnvBoolean, getEnvVar } from '@egr/xbox/utils/ReactScriptHelper';

export const BASKET_WITH_SLIDER: boolean = getEnvBoolean('BASKET_WITH_SLIDER', false);
export const BasketViewScrollId: string = 'egr_basket_view';
export const EGR_BASKET_URL: string | undefined = getEnvVar('EGR_BASKET_URL');
export const OBK_IMAGE_SIZE: number = getEnvNumber('OBK_IMAGE_SIZE', 512);

/** onItemUpdate triggers with this id if no specific item is updated */
export const AllItemsId: string = '###ALL###';
